export default __webpack_public_path__ + "static/media/home.d9c4e8df.png";